module.exports = __webpack_public_path__ + "img/collection-diamondJewelryDelicateJewels.b2300a1.webp";